import { put, call, takeEvery } from "redux-saga/effects";
import athenaClient from "lib/axios/clients";
import { REACT_APP_BASE_URL } from "resources/constants";
import groupAspectsByScopeAndTag from "lib/filters/metadata";
import { setMetadata } from "./slices";
import setMetadataAsyncAction from "./actions";

function* setMetadataAsync(action) {
  const config = {
    method: "GET",
    url: `${REACT_APP_BASE_URL}/columns?delivery_id=${action.payload.delivery_id}`,
  };

  const response = yield call(athenaClient, config);

  yield put(setMetadata(groupAspectsByScopeAndTag(response.data)));
}

export default function* watchSetMetadataAsync() {
  yield takeEvery(setMetadataAsyncAction, setMetadataAsync);
}
